module.exports = __webpack_public_path__ + "static/media/simba.21bdb8ca.jpeg";